<template>
  <div>
    <h2>Review Manuscript</h2>

    <v-row class="mt-5">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <div>
              <div class="d-flex mb-5">
                <v-chip outlined color="brown" label>
                  {{ manuscript.type }}
                </v-chip>

                <v-spacer></v-spacer>

                <v-btn depressed href="#submit-review">Submit Review</v-btn>
              </div>
              <h3 class="paper-title">{{ manuscript.title }}</h3>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <h4>Abstract</h4>
            <div class="abstract" v-html="manuscript.abstract"></div>
            <p>
              <strong class="label mr-2">Keywords:</strong>
              <v-chip
                small
                :key="word"
                color="green lighten-4"
                class="mr-1 my-1"
                v-for="word in manuscript.keywords"
              >
                {{ word }}
              </v-chip>
            </p>
          </v-card-text>
        </v-card>

        <v-card class="my-6">
          <v-card-title> Authors </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <ol>
              <li v-for="(author, index) in manuscript.authors" :key="index">
                <AuthorDetails :author="author" />
              </li>
            </ol>
          </v-card-text>
        </v-card>

        <v-card class="my-6">
          <v-card-title> Uploaded Files </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <ol class="my-4" v-if="manuscript.files.length > 0">
              <li v-for="(file, index) in manuscript.files" :key="index">
                <h3 class="d-flex">
                  {{ file.name }}
                  <v-spacer></v-spacer>
                  <v-btn
                    x-small
                    rounded
                    outlined
                    color="teal"
                    class="mr-1 mb-1"
                    :href="file.location"
                    :download="manuscript.title"
                  >
                    Download File
                  </v-btn>
                </h3>
                <address>
                  <p v-if="file.description">{{ file.description }}</p>
                  <p>{{ formatDate(file.createdAt) }}</p>
                </address>
              </li>
            </ol>
          </v-card-text>
        </v-card>

        <h2 class="text-center" id="submit-review">Submit Manuscript Review</h2>

        <v-card ref="submitReview" class="my-6">
          <v-card-text>
            <WriteReview
              :manuscript="manuscriptId"
              :invitation="invitationId"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { formatDate } from "../../tools/format";
import { required } from "../../tools/rules";
import WriteReview from "./Includes/WriteReview";
import AuthorDetails from "../Author/Includes/AuthorDetails";

export default {
  props: ["manuscriptId", "invitationId"],

  components: { AuthorDetails, WriteReview },

  data: () => ({
    manuscript: { abstract: "", files: [] },
    manuscriptStatus: "INCOMPLETE",
    required,
  }),

  methods: {
    formatDate,
    fetchManuscript() {
      if (this.manuscriptId) {
        this.$axios
          .get(`/manuscript/review/${this.manuscriptId}/${this.invitationId}`)
          .then(({ data: response }) => {
            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Manuscript loaded",
            });

            this.manuscript = response;
            response.manuscriptStatus &&
              (this.manuscriptStatus = response.manuscriptStatus);
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not load manuscript",
            });
            this.$router.go(-1);
          });
      }
    },
  },
  mounted() {
    this.fetchManuscript();
  },
};
</script>

<style scoped lang="scss">
.paper-title {
  word-break: keep-all;
}

.abstract {
  margin: 0.25em 0 1em;
  padding: 0.75em 0.25em;
  white-space: pre-line;
  border-top: 1px dashed #dddddd;
  border-bottom: 1px dashed #dddddd;
  position: relative;

  .copy-abstract {
    top: 0;
    right: 0;
    position: absolute;

    cursor: pointer;
    padding: 0.15em 0.5em;

    opacity: 0;

    // color: #ffffff;
    background: #83c1f3;

    transition: all 300ms ease;
  }

  &:hover {
    .copy-abstract {
      opacity: 1;
    }
  }
}
</style>